import { render, staticRenderFns } from "./channel-add.vue?vue&type=template&id=01a6ae59&scoped=true&"
import script from "./channel-add.vue?vue&type=script&lang=js&"
export * from "./channel-add.vue?vue&type=script&lang=js&"
import style0 from "./channel-add.vue?vue&type=style&index=0&id=01a6ae59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6ae59",
  null
  
)

export default component.exports